import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=82934e9e&scoped=true&"
var script = {}
import style0 from "./foot.vue?vue&type=style&index=0&id=82934e9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82934e9e",
  null
  
)

export default component.exports